const sessionInvalid = 'invalid_session';
const genericError = 'generic_error';
const internalServerError = 'server_error';
export const jpCodes = {
  sessionInvalid,
  genericError,
  internalServerError,
};
